<div style="text-align: -webkit-center;">
    <mat-spinner aria-label="loading" [diameter]="30"></mat-spinner>
</div>